export const vendorPaymentEvent = 'vendorEvent';
export const vendorOrderEvent = 'vendorOrderEvent';
export const vendorOrderInvoiceEvent = 'vendorOrderInvoiceEvent';
export const resetNotificationBadgeCount = 'resetNotificationBadgeCount';
export const userVendorAssociationChanged = 'userVendorAssociationChanged';
export const notificationSettingsUpdated = 'notificationSettingsUpdated';
export const setRecaptchaModal = 'setRecaptchaModal';
